export enum ApiState {
  NeverLoaded = 'NeverLoaded',
  Loading = 'Loading',
  LoadingWithNoData = 'LoadingWithNoData',
  Reloading = 'Reloading',
  Error = 'Error',
  BusinessError = 'BusinessError',
  PaymentError = 'PaymentError',
  Loaded = 'Loaded',
  QuoteSaved = 'QuoteSaved',
}

export enum ApiErrorReasonType {
  Referral = 'Referral',
  InvalidCoverForSumInsured = 'InvalidCoverForSumInsured',
  Declined = 'Declined',
  Embargo = 'Embargo',
  InvalidPromoCode = 'InvalidPromoCode',
  IneligiblePromoCode = 'IneligiblePromoCode',
  ApiLimitReached = 'ApiLimitReached',
  ApiError = 'ApiError',
  Unknown = 'Unknown',
}

export type ErrorPageApiErrorReasonType =
  | ApiErrorReasonType.Referral
  | ApiErrorReasonType.Declined
  | ApiErrorReasonType.Embargo
  | ApiErrorReasonType.ApiError
  | ApiErrorReasonType.ApiLimitReached
  | ApiErrorReasonType.Unknown;

export type ApiErrorReason = {
  type: ApiErrorReasonType;
  message?: string;
  quoteNumber?: string;
  blockingError?: boolean;
  stage?: string;
};

export type ApiData<T> = {
  state: ApiState;
  errorReason?: ApiErrorReason;
  data?: T;
};
